"use strict";
/*
* This is how we resolve props of custom components being spread into primitive components which will result in a error because those primitive
* components dont allow those props. You can either manually try to filter out every custom prop for every custom component before it gets
* sent down or you can provide a list of only approved props for primitive elements and I picked the latter, thus why we have this list.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const validProps = new Set([
    // Journey Props,
    'tooltip',
    'onChange',
    'defaultValue',
    'onBlur',
    'onFocus',
    'onDoubleClick',
    'onClick',
    'placeholder',
    'transition',
    'value',
    'name',
    'step',
    'type',
    'inputmode',
    'inputMode',
    'children',
    'className',
    'id',
    'style',
    'children',
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    // Composition Events
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    // Focus Events
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    // Form Events
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    // Image Events
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    // Keyboard Events
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    // popper
    'data-popper-arrow',
    'data-popper-placement',
    // Media Events
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    // MouseEvents
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    // Selection Events
    'onSelect',
    'onSelectCapture',
    // Touch Events
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    // Pointer Events
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    // UI Events
    'onScroll',
    'onScrollCapture',
    // Wheel Events
    'onWheel',
    'onWheelCapture',
    // Animation Events
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    // Transition Events
    'onTransitionEnd',
    'onTransitionEndCapture',
    // Motion # https://github.com/framer/motion/blob/5112520fecc77f7c8eb95af2de342c82599861fd/src/motion/utils/valid-prop.ts#L59
    'initial',
    'animate',
    'exit',
    'style',
    'variants',
    'transition',
    'transformTemplate',
    'transformValues',
    'custom',
    'inherit',
    'layout',
    'layoutId',
    'onLayoutAnimationComplete',
    'onViewportBoxUpdate',
    'onLayoutMeasure',
    'onBeforeLayoutMeasure',
    'onAnimationStart',
    'onAnimationComplete',
    'onUpdate',
    'onDragStart',
    'onDrag',
    'onDragEnd',
    'onMeasureDragConstraints',
    'onDirectionLock',
    'onDragTransitionEnd',
    'drag',
    'dragControls',
    'dragListener',
    'dragConstraints',
    'dragDirectionLock',
    '_dragX',
    '_dragY',
    'dragElastic',
    'dragMomentum',
    'dragPropagation',
    'dragTransition',
    'whileDrag',
    // react-slider
    'ariaLabel',
    'ariaValuetext',
    'className',
    'defaultVale',
    'disabled',
    'invert',
    'markClassName',
    'marks',
    'max',
    'min',
    'minDistance',
    'onAfterChange',
    'onBeforeChange',
    'onChange',
    'onSliderClick',
    'orientation',
    'pageFn',
    'pearling',
    'renderMark',
    'renderThumb',
    'renderTrack',
    'snapDragDisabled',
    'step',
    'thumbActiveClassName',
    'thumbClassName',
    'trackClassName',
    'value',
    'withTracks',
    // Standard HTML Attributes
    'accept',
    'acceptCharset',
    'action',
    'allowFullScreen',
    'allowTransparency',
    'alt',
    'as',
    'async',
    'autoComplete',
    // 'autoFocus',
    'autoPlay',
    'capture',
    'cellPadding',
    'cellSpacing',
    'charSet',
    'challenge',
    'checked',
    'cite',
    'classID',
    'cols',
    'colSpan',
    'content',
    'controls',
    'coords',
    'crossOrigin',
    'data',
    'dateTime',
    'default',
    'defer',
    'disabled',
    'download',
    'encType',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'frameBorder',
    'headers',
    'height',
    'high',
    'href',
    'hrefLang',
    'htmlFor',
    'for',
    'httpEquiv',
    'integrity',
    'keyParams',
    'keyType',
    'kind',
    // 'label', // field uses label, doesnt need to be on DOM ele
    'list',
    'loop',
    'low',
    'manifest',
    'marginHeight',
    'marginWidth',
    'max',
    'maxLength',
    'media',
    'mediaGroup',
    'method',
    'min',
    'minLength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noValidate',
    'open',
    'optimum',
    'pattern',
    'placeholder',
    'playsInline',
    'poster',
    'preload',
    'readOnly',
    'rel',
    'required',
    'reversed',
    'rows',
    'rowSpan',
    'sandbox',
    'scope',
    'scoped',
    'scrolling',
    'seamless',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'src',
    'srcDoc',
    'srcLang',
    'srcSet',
    'start',
    'step',
    'summary',
    'target',
    'type',
    'useMap',
    'value',
    'width',
    'wmode',
    'wrap',
]);
function isValidProp(key) {
    if (key.startsWith('data')) {
        return true;
    }
    return validProps.has(key);
}
exports.default = isValidProp;
